import React, { useEffect, useState } from "react";

import { useSelector, useDispatch } from "react-redux";

import { useNavigate } from "react-router-dom";

// Import supabase configuration
import supabase from "../../config/supabase";

// import { Grid,Paper, TextField, Button } from '@material-ui/core'
import { Grid, Paper, TextField, InputBase, Button, InputLabel } from "@mui/material";
import { makeStyles } from "@material-ui/core/styles";
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import InputAdornment from '@mui/material/InputAdornment';
import IconButton from '@mui/material/IconButton';
import { styled } from '@mui/material/styles';
import LinearProgress, { linearProgressClasses } from '@mui/material/LinearProgress';
import Box from "@mui/material/Box";
import OutlinedInput from '@mui/material/OutlinedInput';
import FormControl from '@mui/material/FormControl';
import { Buffer } from "buffer";
import { loginUser, signupUser } from "../../redux/actions/actions";
import { borderRadius } from "@mui/system";
import mixpanel from 'mixpanel-browser';


const Login = (props) => {

  const [values, setValues] = React.useState({
    password: '',
    email: '',
    showPassword: false,
  });
  const [errorMessage, setErrorMessage] = useState("");
  const { currentUser } = useSelector((state) => state.user);
  
  const dispatch = useDispatch();
  const navigate = useNavigate();
  
  
  const btnstyle = { margin: `${!errorMessage ? "20px 0 0 0" : ''}`, backgroundColor: "#0F69F6", fontSize: "16px", width: "48%", borderRadius: "4px", textTransform : 'none',};
  const loginbtnstyle = { margin: `${!errorMessage ? "20px 0 0 0" : ''}`, backgroundColor: "#0F69F6", fontSize: "16px", height: '41px', borderRadius: "4px", textTransform : 'none',};
  const Secondbtnstyle = { margin: `${!errorMessage ? "20px 0 0 0" : ''}`, backgroundColor: "#FF4974", fontSize: "16px", width: "48%", borderRadius: "4px", textTransform : 'none',};

  const handleSubmit = async(e) => {
    e.preventDefault();
    mixpanel.init('de405b9420bcdeddec4d225dc80801ec'); 
    var { data, error } = await supabase
    .from("board_clients_invitation")
    .select("*")
    .match({email: values.email});

    if(data && data.length){
        dispatch(loginUser(values.email, values.password))
        .then(() => {
        mixpanel.track('Logged in from dashboard',{
            'email':  values.email,
        });
        mixpanel.identify(data[0].id);
        mixpanel.people.set({
            $email: values.email,
            $name: values.email,
        });
        localStorage.setItem("loggedIn", true);
        localStorage.removeItem("needLogin");
        sessionStorage.removeItem("publicInfo");
        props.handleCloseModal();
        
        setValues({
            password: '',
            email: '',
            showPassword: false,
        });

        let dash_id = Buffer.from(data[0].dashboard_id, "utf-8").toString("base64");
        let link = "dashboard=" + dash_id;
        localStorage.setItem("dashboard", link);

        })
        .catch(() => {
        setErrorMessage("Invalid email or password");
        console.log("Error");
        });
    }
    else{
        setErrorMessage("You do not have access to this board");
    }
  };

  const handleClickShowPassword = (e) => {
    setValues({
      ...values,
      showPassword: !values.showPassword,
    });
  };

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  const handleChange = (prop) => (event) => {
    setValues({ ...values, [prop]: event.target.value });
  };

  const handleNotNowClick = () => {
    mixpanel.track('Skip from client dashbaord',{
      'email':  values.email,
    });
    localStorage.setItem("loggedIn", false);
    setValues({
      password: '',
      email: '',
      showPassword: false,
    });
    props.handleCloseModal();
  }

  return (
        <div className="flex justify-center">
          <Grid
            container
            direction="column"
            justifyContent="space-between"
            alignItems="center"
            style={{ marginTop: "12px", backgroundColor: '#232428', padding: "40px 20px 20px 20px", borderRadius: '4.27px'}}
          >
              <Grid align="center">
                <h1 className="text-[#969696] text-xs 1xl:text-base">WELCOME BACK</h1>
                <h1 className="text-[#FFFFFF] font-semibold text-lg xl-2:text-1xl">Log into your account</h1>
              </Grid>
                
                  <form className="w-full mt-5" onSubmit={handleSubmit}>
                    <div>
                      <div>
                      </div>
                      <InputBase
                        variant="standard"
                        type='text'
                        value={values.email}
                        placeholder="Enter your email"
                        onChange={handleChange('email')}
                        style={{color: "#FFFFFF",
                        borderBottom: "0.2px solid #FFFFFF",
                        position: 'relative',
                        borderRadius: 1.65,
                        height: '35px',
                        marginTop: '15px',
                        marginBottom: '20px',
                        fontSize: 16,
                        padding: '10px 18px',
                      }}
                      fullWidth
                      onClick={() => setErrorMessage("")}
                      required
                      />
                      <div>
                      </div>
                      <InputBase
                        variant="standard"
                        type={values.showPassword ? 'text' : 'password'}
                        value={values.password}
                        placeholder="Enter your Password"
                        onChange={handleChange('password')}
                        style={{color: "#FFFFFF",
                        borderBottom: "0.2px solid #FFFFFF",
                        position: 'relative',
                        borderRadius: 1.65,
                        height: '35px',
                        marginTop: '10px',
                        marginBottom: '15px',
                        fontSize: 16,
                        padding: '10px 18px',
                      }}
                      fullWidth
                        endAdornment={
                          <InputAdornment position="end">
                            <IconButton
                              style={{color: '#474747', }}
                              aria-label="toggle password visibility"
                              onClick={handleClickShowPassword}
                              onMouseDown={handleMouseDownPassword}
                              edge="end"
                            >
                              {values.showPassword ? <VisibilityOff style={{width: '20px'}} /> : <Visibility style={{width: '20px' }} />}
                            </IconButton>
                          </InputAdornment>
                        }
                        label="Password"
                        onClick={() => setErrorMessage("")}
                        required
                      />
                    </div>
                  {errorMessage && (
                    <div className="my-2 flex text-right text-sm text-red-1 col-span-12">{errorMessage}</div>
                    )}
                  <div className="flex justify-between mb-5">
                    <Button
                        type="button"
                        variant="contained"
                        size="medium"
                        style={Secondbtnstyle}
                        onClick={handleNotNowClick}
                        fullWidth
                        >
                        Skip
                    </Button>

                    <Button
                      type="submit"
                      variant="contained"
                      size="medium"
                      style={btnstyle}
                      fullWidth
                      >
                      Log In
                    </Button>
                  </div>
                  </form>
                
          </Grid>
        </div>
  );
};

export default Login;
